export enum CheckModel {
  ALL = 'all',
  PARENT = 'parent',
  LEAF = 'leaf',
}

export const TREE_INDENT_WIDTH = 20 // px

export const EXPAND_ARROW_WIDTH = 18 // px
